import React from 'react';
import { useTranslate } from 'react-admin';
import { Box } from '@material-ui/core';
import MuiDrawer from '../../../../base/components/mui/MuiDrawer';
import MuiTabs from '../../../../base/components/mui/MuiTabs';
import MuiTab from '../../../../base/components/mui/MuiTab';
import DetailsTab from './DetailsTab';
import ChangeLogTab from './ChangeLogTab';
import { useRewardTabSync } from '../../hooks/useRewardTabSync';

const RewardDetailsDrawer = () => {
  const t = useTranslate();
  const { rewardId: id, rewardTab, setRewardTab } = useRewardTabSync();

  const open = !!id && (rewardTab === 'view' || rewardTab === 'changeLog');

  return (
    <MuiDrawer open={open} anchor="right" onClose={() => setRewardTab()} title={t('resources.reward.reward-details')}>
      {open ? (
        <>
          <MuiTabs value={rewardTab}>
            <Box
              component={MuiTab}
              sx={{
                flexGrow: 1,
                maxWidth: 'unset',
              }}
              value="view"
              label={t('resources.reward.details')}
              onClick={() => setRewardTab(id, 'view')}
            />
            <Box
              component={MuiTab}
              sx={{
                flexGrow: 1,
                maxWidth: 'unset',
              }}
              value="changeLog"
              label={t('resources.reward.change-logs')}
              onClick={() => setRewardTab(id, 'changeLog')}
            />
          </MuiTabs>
          {rewardTab === 'view' && <DetailsTab />}
          {rewardTab === 'changeLog' && <ChangeLogTab />}
        </>
      ) : null}
    </MuiDrawer>
  );
};

export default RewardDetailsDrawer;
